<script>
import { axiosGetPost } from '@router/axiosGetPost'
import HarborCreate from '@components/contract/harbor-create'
import Multiselect from 'vue-multiselect'

export default {
  name: 'HarborManager',
  props: {
    nameVariation: { type: String, default: null },
  },
  components: {
    HarborCreate,
    Multiselect,
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus()
      },
    },
  },
  data() {
    return {
      loading: false,
      harbor: null,
      displayName: null,
      harborList: [],
      harborVariation: this.nameVariation,
      harborVariations: [],
      addNewHarbor: false,
    }
  },
  methods: {
    searchHarbor(harborName, loading) {
      axiosGetPost('post', '/cargofive/harbors/manage', {
        action: 'search',
        harborName,
      }).then((response) => {
        this.harborList = response.list
      })
    },
    getVariations() {
      this.loading = true
      axiosGetPost('post', '/cargofive/harbors/manage', {
        action: 'list',
        harborId: this.harbor.id,
      }).then((response) => {
        this.displayName = response.display_name
        this.harborVariations = response.variations.map((h, i) => ({
          index: i,
          name: h,
          editing: false,
        }))
        this.loading = false
      })
    },
    manageVariation(action, variation, variationId = 0) {
      this.loading = true
      axiosGetPost('post', '/cargofive/harbors/manage', {
        harborId: this.harbor.id,
        action,
        variation,
        variationId,
      }).then((response) => {
        this.harborVariation = action === 'add' ? '' : this.harborVariation
        this.harborVariations = response.variations.map((h, i) => ({
          index: i,
          name: h,
          editing: false,
        }))
        this.getVariations()
        this.loading = false
      })
    },
    addNew() {
      this.addNewHarbor = !this.addNewHarbor
      this.harbor = null
      this.harborList = []
      this.harborVariations = []
    },
  },
}
</script>

<template>
  <div class="row">
    <div class="col-12">
      <div class="row form-group">
        <div class="col-10">
          <multiselect
            v-model="harbor"
            id="ajax"
            label="name"
            track-by="fullData"
            placeholder="Search harbor"
            open-direction="bottom"
            :multiple="false"
            :searchable="true"
            :loading="loading"
            :internal-search="true"
            :disabled="addNewHarbor"
            :reduce="(options) => options.id"
            :options="harborList"
            @search-change="searchHarbor"
            @input="getVariations"
          ></multiselect>
        </div>

        <div class="col-2">
          <button
            v-if="addNewHarbor === false"
            class="btn btn-sm my-1 btn-outline-secondary"
            title="Add New"
            @click="addNew"
          >
            Add New <i class="uil uil-plus"></i>
          </button>
          <button
            v-else
            class="btn btn-sm my-1 btn-outline-danger"
            title="Add New"
            @click="addNew"
          >
            &nbsp;&nbsp;Cancel <i class="uil uil-multiply"></i>&nbsp;&nbsp;
          </button>
        </div>
      </div>
    </div>
    <div v-if="loading && !addNewHarbor" class="col-12">
      <div
        class="row align-items-center justify-content-center"
        style="height: 350px"
      >
        <div class="col-12 col-md-8 text-center">
          <b-spinner
            label="Loading..."
            variant="secondary"
            class="ml-3"
          ></b-spinner>
        </div>
      </div>
    </div>
    <div
      v-else-if="harborVariations.length > 0 && !addNewHarbor"
      class="col-12"
    >
      <b>
        <label for="display Name">Display Name:&nbsp;</label>
        <i style="color: #4b4bc9"> {{ displayName }}</i></b
      >
      <div class="row" style="height: 300px; overflow-y: scroll">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table table-striped mb-0">
              <tbody>
                <tr v-for="h in harborVariations" :key="h.index">
                  <th scope="row">{{ h.index }}</th>
                  <td>
                    <input
                      v-if="h.editing"
                      v-model="h.name"
                      v-focus
                      class="w-100"
                      @keyup.enter="manageVariation('edit', h.name, h.index)"
                      @blur="manageVariation('edit', h.name, h.index)"
                    />
                    <p v-else>
                      {{ h.name }}
                    </p>
                  </td>
                  <td style="text-align: end">
                    <button
                      class="btn btn-sm btn-info ml-2"
                      @click="h.editing = !h.editing"
                    >
                      <i class="uil uil-edit"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-danger ml-2"
                      @click="manageVariation('delete', h.name)"
                    >
                      <i class="uil uil-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <input
            v-model="harborVariation"
            type="text"
            class="form-control"
            placeholder="new variation"
          />
        </div>
        <div class="col-12 col-md-3">
          <button
            class="btn btn-success w-100"
            @click="manageVariation('add', harborVariation)"
          >
            Add
          </button>
        </div>
      </div>
    </div>
    <div class="w-100" v-else-if="addNewHarbor">
      <HarborCreate @update_view="addNew" />
    </div>
    <div v-else class="col-12">
      <div
        class="row align-items-center justify-content-center"
        style="height: 350px"
      >
        <div class="col-12 col-md-8 text-center">
          <feather type="anchor" class="icon-xxl icon-dual-info"></feather>
          <h6 class="text-muted">Select a harbord</h6>
        </div>
      </div>
    </div>
  </div>
</template>
